/* ----------------------------------------------------------------
   Kushface - PDP main image loading skeleton
   Progressive enhancement: the shared .kf-skel primitive is invisible
   until JS adds `is-loading` to the host. No JS, or a cached/already-
   painted image, means `is-loading` is never set, so the image just
   shows — never a stuck-invisible state. Only toggles classes on the
   media element; the lightbox button, scanline, and variant select
   are untouched. No deps. Mirrors carousel-3d.js skeleton loop.
   ---------------------------------------------------------------- */

(function () {
  "use strict";

  var media = document.querySelector(".kf-pdp__media");
  if (!media) return;

  var img = media.querySelector(".kf-pdp__img[data-skel-fade]");
  if (!img) return;

  // Cached/already-painted image: no skeleton flash.
  if (img.complete && img.naturalWidth > 0) return;

  media.classList.add("is-loading");
  function settleImg() { media.classList.remove("is-loading"); }
  img.addEventListener("load", settleImg, { once: true });
  img.addEventListener("error", settleImg, { once: true });
})();
